import React from 'react';
import {__} from '@wordpress/i18n';
import {Box, Typography} from '@lapilli-ui/components';

const RelatedContent = ({label, posts, background, maxResults}) => {

  let relatedContents = false;

  if (posts && posts.length) {
    if (posts.length > maxResults) {
      relatedContents = posts.slice(0, maxResults);
    } else {
      relatedContents = posts;
    }
  }
  return (
      <Box className="ywcas-related-content" sx={{
        background: background,
      }}>
        <Typography className="ywcas-related-content__label">{label}</Typography>
        {relatedContents && relatedContents.map(post =>
            <Typography className="ywcas-related-content__link" key={post.id}>
              > <a key={post} href={post.url}>{post.name}</a>
            </Typography>,
        )}
        {!relatedContents && <Typography className="ywcas-related-content__no_result">{__('No related content found', 'yith-woocommerce-ajax-search')}</Typography>}
      </Box>
  );
};
export default RelatedContent;